



































import Vue from 'vue';
import {
  Modal,
  ModalMixin,
  openModal,
  Loader,
  notify,
} from 'mycorems-app-shared';
import { subscribe, recognition } from 'mycorems-app-accounts';
import isGranted from '@/auth/isGranted';
import {
  ExternalClient, Client, ListElement, ModalElement,
} from '@/types';
import AccountSettingsModal from '@/account-settings/AccountSettingsModal.vue';
import ExternalClientsList from './ExternalClientsList.vue';
import { add } from '.';
import FreeCreditsModal from './FreeCreditsModal.vue';
import AddClientConfirmationModal from './AddClientConfirmationModal.vue';

interface Data {
  task: Promise<Client>|null,
  externalClient: ExternalClient|null,
}

export default Vue.extend({
  mixins: [ModalMixin],
  props: {
    agencyId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      externalClient: null,
    };
  },
  computed: {
    getUserId(): string|null {
      return recognition.getUserId();
    },
  },
  methods: {
    add(externalClient: ExternalClient) {
      this.externalClient = externalClient;
      this.task = add(this.agencyId, externalClient.id);
      this.task.then((client: Client) => {
        if (this.externalClient) {
          (this.$refs.externalClients as ListElement).removeItem(this.externalClient);
        }
        this.externalClient = null;
        if (this.getUserId) {
          subscribe(client.id, this.getUserId);
        }
        this.freeTrial(client);
      });
    },
    freeTrial(client: Client) {
      openModal(FreeCreditsModal, { client })
        .onOk(() => {
          this.reviewSettings(client);
        });
    },
    reviewSettings(client: Client) {
      const modalConfig = {
        parent: this,
        accountId: client.id,
        title: `Choose report settings for ${client.name}`,
      };
      openModal(AccountSettingsModal, modalConfig).onDismiss(() => {
        this.complete(client);
      });
    },
    complete(client: Client): void {
      openModal(AddClientConfirmationModal, {
        title: `${client.name} Successfully Added`,
      }).onCancel(() => {
        this.$emit('ok');
        (this.$refs.modal as ModalElement).hide();
        notify.success(`${client.name} has been added.`);
      }).onOk(() => {
        notify.success(`${client.name} has been added.`);
      });
    },
    isGranted,
  },
  components: {
    Modal,
    ExternalClientsList,
    Loader,
  },
});
